import { render, staticRenderFns } from "./ChbPortChargesFormTable.vue?vue&type=template&id=5bad3e62&scoped=true"
import script from "./ChbPortChargesFormTable.vue?vue&type=script&lang=js"
export * from "./ChbPortChargesFormTable.vue?vue&type=script&lang=js"
import style0 from "./ChbPortChargesFormTable.vue?vue&type=style&index=0&id=5bad3e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bad3e62",
  null
  
)

export default component.exports